const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/post/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/post/$id.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildCanonicalAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { withSiteTitle } from "@/lib/page-title";
import { ROLLOUT_NOINDEX_ROBOTS } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/post/$id")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData,
    params
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    const path = `/post/${params.id}`;
    const alts = buildCanonicalAlternates(path);
    const post = loaderData?.post;
    if (!post) {
      return {
        meta: [{
          title: withSiteTitle(tMeta("post"))
        }]
      };
    }
    const title = post.content?.slice(0, 60) || tMeta("post");
    const url = alts.canonical;
    return {
      meta: await buildPagePreviewMetaTags({
        title,
        description: tMeta("postPreviewDescription"),
        canonicalUrl: url
      }, {
        robots: ROLLOUT_NOINDEX_ROBOTS,
        openGraph: {
          type: "article"
        }
      }, {
        locale
      }),
      links: [{
        rel: "canonical",
        href: alts.canonical
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});